import {
  AppSelect,
  TOption,
} from '../../../components/appSelect';
import responsiveLayoutLogo from '../../../assets/icons/responsive_layout.svg';

type TProps = {
  selectedValue: string;
  onChange: (val: string) => void;
};

const OPTIONS: TOption[] = [
  {
    value: '1:1',
    label: 'Square',
    icon: (
      <div className="option_icon w-[20px] h-[20px]">
        1:1
      </div>
    ),
  },
  {
    value: '7:4',
    label: 'Horizontal',
    icon: (
      <div className="option_icon w-[36px] h-[20px]">
        7:4
      </div>
    ),
  },
  {
    value: '4:7',
    label: 'Vertical',
    icon: (
      <div className="option_icon w-[20px] h-[36px]">
        4:7
      </div>
    ),
  },
];

export const AspectRatio = ({
  selectedValue,
  onChange,
}: TProps) => {
  return (
    <AppSelect
      label="Aspect Ratio"
      selectIcon={responsiveLayoutLogo}
      selectedValue={selectedValue}
      onChange={onChange}
      options={OPTIONS}
    />
  );
};
